import styled from 'styled-components'
import { grayLight } from '@bufferapp/ui/style/colors'

import { flexRow } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Wrapper = styled.div`
  ${flexRow}
  color: ${(props) => props.color || 'inherit'};
`

export const Value = styled.p`
  ${baseFont}
  font-weight: 500;
  margin-left: 2px;
  color: ${(props) => props.color || 'inherit'};
`

export const Placeholder = styled.div`
  width: 30px;
  height: 13px;
  background-color: ${grayLight};
  margin: 0px 4px;
`
